import * as types from 'store/mutation-types'
import store from 'store'

function featureExists (source, featureName) {
  return source && source.hasOwnProperty(featureName)
}

function isFeaturePerUser (feature) {
  return Array.isArray(feature)
}

function isFeatureEnabled (features, itemName) {
  const userData = store.state.auth.user

  if (userData) {
    const { id: userId } = userData

    if (featureExists(features, itemName)) {
      const feature = features[itemName]

      if (isFeaturePerUser(feature)) {
        return feature.includes(userId)
      }

      return Boolean(feature)
    }
  }

  return true
}

function checkUserFeature (currentFeature, itemName) {
  const userData = store.state.auth.user

  if (userData) {
    const { id: userId } = userData

    if (featureExists(currentFeature, itemName)) {
      return currentFeature[itemName].includes(userId)
    }
  }

  return false
}

const state = {
  features: {
    slots: {},
    components: {},
    general: {}
  }
}

const getters = {
  isSlotEnabled: ({ features }, getters) => name => {
    return isFeatureEnabled(features.slots, name)
  },
  isComponentEnabled: ({ features }, getters) => name => {
    return isFeatureEnabled(features.components, name)
  },
  isFeatureEnabled ({ features }) {
    return name => {
      return checkUserFeature(features.general, name)
    }
  }
}

const mutations = {
  [types.STORE_FEATURE_RULES] (state, features) {
    state.features = features
  }
}

export default {
  state,
  getters,
  mutations,
  namespaced: true
}
